import { getInitialSelectedUser } from '../../helpers/selectedUser'
import { addOrUpdateUser } from './helpers'
import { UsersAction } from './actions'
import { User } from './types'

export interface State {
  users?: User[]
  pending: boolean
  error: boolean
  selectedUser: number
}

export const initialState: State = {
  users: undefined,
  pending: true,
  error: false,
  selectedUser: getInitialSelectedUser()
}

export default (state = initialState, action: UsersAction): State => {
  switch (action.type) {
    case 'users.fetch':
      return {
        ...state,
        pending: true,
        users: undefined,
        error: false
      }
    case 'users.fetchFail':
      return {
        ...state,
        pending: false,
        error: true
      }

    case 'users.addUsers':
      let items: User[] = []

      if ('payload' in action) {
        items = action.payload ?? []
      }

      if (!state.users) {
        return {
          ...state,
          users: items
        }
      }

      return {
        ...state,
        users: addOrUpdateUser(state.users, items)
      }
    case 'users.setSelectedUser':
      let userId = 0
      if ('payload' in action) {
        userId = action.payload ?? 0
      }
      return {
        ...state,
        selectedUser: userId
      }
    default:
      return state
  }
}
